var React = require('react');

function Intersection (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 224v240a16 16 0 0 1-16 16h-64a16 16 0 0 1-16-16V227.79c0-46.43-31.29-89.08-76.87-97.93A96.16 96.16 0 0 0 96 224v240a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V230.68C0 133.11 70 46 166.74 33.62 283.83 18.6 384 109.82 384 224z","className":"fa-secondary","key":1})]);
}

Intersection.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Intersection;

Intersection.default = Intersection;
